<template>
  <div class="email-cell">
    <a class="text-red hover-bold" :href="`mailto:${email}`">
      {{ email }}
    </a>
  </div>
</template>

<script>
export default {
  name: "EmailCell",
  props: {
    email: String
  }
};
</script>
